import * as DOMHelpers from './DOMHelpers';
import * as NetteAjax from './NetteAjax';
import * as ReCaptcha from './GoogleReCaptcha';

const moduleName = 'NetteAjaxForm';

function prepareInputsValues(state) {
    let body = new FormData(state.formElement);

    return Object.assign({}, state, {
        body: body
    });
}

function prepareMethod(state) {
    return Object.assign({}, state, {
        method: state.formElement.getAttribute('method').toUpperCase()
    });
}

function prepareUrl(state) {
    return Object.assign({}, state, {
        url: state.formElement.getAttribute('action')
    });
}

function startSpinner(state) {
    let spinner = state.button.querySelector('[data-status="spinner"]');

    if(spinner) {
        spinner.classList.remove('d-none');
    }

    return Object.assign({}, state, {
        spinner: spinner
    });
}

function removeSpinner(state) {
    if(state.spinner) {
        state.spinner.classList.add('d-none')
    }

    return Object.assign({}, state, {
        spinner: state.spinner,
    });
}

function getSubmitButton(state) {
    let activeElement = document.activeElement;
    let activeIsButton = activeElement && activeElement.getAttribute('type') === 'submit';

    return Object.assign({}, state, {
        button: activeIsButton ? activeElement : state.formElement.querySelector('[type="submit"]')
    });
}

function applyReCaptcha(state) {
    ReCaptcha.applyToForm(state.formElement);
    return state;
}

function processSubmit(form, event) {
    return NetteAjax.sendRequest(
        prepareInputsValues(
            prepareUrl(
                prepareMethod(
                    startSpinner(
                        getSubmitButton(
                            {formElement: form, event: event}
                        )
                    )
                )
            )
        )
    ).then(response => {
        return removeSpinner(response);
    }).then(response => {
        return applyReCaptcha(response);
    });
}

function initializeAjaxForm(formElement) {
    formElement.addEventListener('submit', function(event) {
        event.preventDefault();
        formElement[moduleName].process(event);
    });

    return {
        process: function(event) {
            processSubmit(formElement, event);
        }
    };
}

function factory(formElement) {
    if(formElement[moduleName] === undefined) {
        formElement[moduleName] = initializeAjaxForm(formElement);
    }
}

export function initialize(selector) {
    DOMHelpers.iterateQuerySelectorAll(document, selector, function(formElement) {
        factory(formElement);
    });
}
